import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SubscriptionForm from '../components/SubscriptionForm';
import { useMutateSubscriptionHandler } from '../dataHandlers/mutateSubscriptionHandler';

export default function SubscriptionCreatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onSubmit, error, isPending } = useMutateSubscriptionHandler({
    onSuccess: () => navigate('/subscriptions'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SubscriptionForm
        onSubmit={(payload) => onSubmit(payload, false)}
        onCancel={() => navigate('/subscriptions')}
        initialData={{ stripe_customer_id: '', items: [] }}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
